import { render } from "./MenuPrincipal.vue?vue&type=template&id=5b668c84&scoped=true"
import script from "./MenuPrincipal.vue?vue&type=script&lang=js"
export * from "./MenuPrincipal.vue?vue&type=script&lang=js"

import "./MenuPrincipal.vue?vue&type=style&index=0&id=5b668c84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b668c84"]])

export default __exports__